import { ReactNode } from 'react';

interface SwirlHeroProps {
  full?: boolean;
  gain?: number;
  flare?: boolean;
  noise?: boolean;
  mode?: string;
  children?: ReactNode;
  gradientColors?: string[];
}

export function SwirlHero({ full = false, gain = 1, flare = true, noise = false, mode = 'focus', children, gradientColors = ['rgba(59,130,246,0.8)', 'rgba(147,51,234,0.6)', 'rgba(236,72,153,0.8)'] }: SwirlHeroProps) {
  return (
    <div
      data-testid="identity-hero"
      className={`${full ? "relative h-full w-full rounded-[22px]" : "relative aspect-[21/9] w-full rounded-[22px]"} border border-white/10 p-1 shadow-[0_10px_60px_-10px_rgba(0,0,0,0.6)]`}
              style={{
          backgroundImage: `linear-gradient(135deg, ${gradientColors.join(', ')})`,
          borderRadius: '22px'
        }}
    >
      <div data-testid="identity-hero-inner" className="relative h-full w-full overflow-hidden rounded-[calc(22px-4px)] bg-black">
        {noise && (
          <div aria-hidden className="pointer-events-none absolute inset-0 opacity-10 mix-blend-soft-light" style={{ backgroundImage: 'repeating-linear-gradient(45deg, #fff1 0 2px, transparent 2px 6px)' }} />
        )}
        <div className="relative z-10 h-full w-full">{children}</div>
        <div aria-hidden className="pointer-events-none absolute inset-0 rounded-[inherit]" style={{ boxShadow: 'inset 0 1px rgba(255,255,255,0.04), inset 0 -1px rgba(0,0,0,0.35)' }} />

      </div>
    </div>
  );
}
